import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import dayjs from '../src/util/configuredDayJs';

import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import 'dayjs/locale/th';

// The locale JSONs are the only assets we serve that are NOT content-hashed, so a browser holding
// an older copy will keep using it and i18next will silently fall back to English for any key added
// since — no error, just the wrong language. Stamping the request with the main bundle's content
// hash (which CRA regenerates on every build) gives the locale files the same cache identity the
// rest of the build already has, so a new build can never read a previous build's translations.
const buildId =
  (document.querySelector('script[src*="/static/js/main."]') || {}).src?.match(/main\.([^.]+)\./)?.[1] || 'dev';

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      queryStringParams: { v: buildId },
    },
    detection: {
      order: ['htmlTag'],
    },
    react: {
      useSuspense: true,
    },
    fallbackLng: 'en',
    ns: [
      'chemical',
      'client',
      'dashboard',
      'loginpage',
      'navigation',
      'notfound',
      'organization',
      'plot',
      'report',
      'site',
      'system',
      'task',
      'ui',
      'unit',
      'user',
      'variety',
      'fertilizer',
    ],
    debug: true,
    interpolation: {
      format: function (value, format, lng) {
        if (value instanceof Date) {
          return dayjs(value).format(format);
        }
        return value;
      },
      escapeValue: false,
    },
  });

i18next.on('initialized', function (options) {
  const { fallbackLng, lng } = options;
  if (lng) {
    dayjs.locale(lng);
  } else {
    dayjs.locale(fallbackLng);
  }
});

i18next.on('languageChanged', function (lng) {
  dayjs.locale(lng);
});

export default i18next;
